import { useQuery } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";

import { useRestClient } from "@/lib/restClient";
export interface Account {
  account_id: string;
  email: string;
  roles: string[];
  tenant_id: number | null;
  profile: string;
  scopes: string[];
  settings: Record<string, unknown>;
  demo_enabled?: boolean;
  /** Data, tenants and dashboards are bounded by `scopes` (client profiles). */
  data_limited_to_scopes?: boolean;
}

export function useAccount() {
  const auth = useAuth();
  const apiFetch = useRestClient();

  return useQuery({
    queryKey: ["account"],
    queryFn: ({ signal }) => apiFetch<Account>("/api/account", { signal }),
    enabled:
      !auth.isLoading && auth.isAuthenticated && !!auth.user?.access_token && !auth.user.expired,
    staleTime: 5 * 60_000,
  });
}

/** True when the current account resolves to the product administrator profile. */
export function useIsAdmin(): boolean {
  const { data } = useAccount();
  return data?.profile === "nagra-admin";
}
